import { Plus } from 'lucide-react';
import type { ReactNode } from 'react';

interface PrivateEventsPageHeaderProps {
  onCreate: () => void;
  /** The region picker, worn beside the title on its baseline. */
  scope: ReactNode;
}

/**
 * The private-events page header band (BON-518) — breadcrumb eyebrow, display
 * title, primary action. Same shape as `ListPageHeader`: full-bleed above
 * the padded content, which is the slot `DashboardsPage` leaves for it.
 */
export default function PrivateEventsPageHeader({ onCreate, scope }: PrivateEventsPageHeaderProps) {
  return (
    <header
      style={{
        flex: '0 0 auto',
        display: 'flex',
        alignItems: 'flex-end',
        gap: 24,
        padding: '22px 32px 14px',
        flexWrap: 'wrap',
      }}
    >
      <div style={{ minWidth: 0 }}>
        <div className="nb-eyebrow" style={{ marginBottom: 4, color: 'var(--nb-muted)' }}>
          Workshops › Private events
        </div>
        <div style={{ display: 'flex', alignItems: 'baseline', gap: 14, flexWrap: 'wrap' }}>
          <h1
            className="nb-display"
            style={{ margin: 0, fontSize: 30, color: 'var(--nb-ink)', letterSpacing: '0.01em' }}
          >
            Private events
          </h1>
          {scope}
        </div>
      </div>
      <div style={{ flex: 1 }} />
      <button
        type="button"
        onClick={onCreate}
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 6,
          marginBottom: 2,
          padding: '7px 13px',
          borderRadius: 'var(--nb-radius-btn)',
          background: 'var(--nb-primary)',
          color: 'var(--nb-on-primary)',
          fontSize: 12,
          fontWeight: 700,
        }}
      >
        <Plus size={14} /> New private event
      </button>
    </header>
  );
}
